import { createSignalRContext } from 'react-signalr/signalr';

// A dedicated SignalR connection for the real-time notification hub.
// `react-signalr`'s `createSignalRContext` manages exactly one connection per
// context, so this is kept separate from the single-login hub's context.
export const NotificationSignalRContext = createSignalRContext();
